import React from 'react';

export const MemberOnlyTierLabel = () => (
    <div className="flex items-center h-8 rounded-md bg-[#F6F6F6]">
      <div className="mx-2">
        <img src="/img/community.svg" />
      </div>
      <span className="text-[#787878] text-xs font-bold uppercase">
        Member-only access
      </span>
    </div>
  );
